import en from './locale/en';
import vi from './locale/vi';

export default {
  en,
  vi,
};
